import ApiBase from 'Services/Api/ApiBase';

class NarrativeSchedule extends ApiBase {
    route = '/service-users/narrative-schedule';
};

export default new NarrativeSchedule();